import { render } from "./Directorio.vue?vue&type=template&id=4feeb1e9&scoped=true"
import script from "./Directorio.vue?vue&type=script&lang=ts"
export * from "./Directorio.vue?vue&type=script&lang=ts"

import "./Directorio.vue?vue&type=style&index=0&id=4feeb1e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4feeb1e9"

export default script